// src/auth.js
import { OktaAuth } from '@okta/okta-auth-js';
import config from '../../config';

const isLocalhost = window.location.hostname === 'localhost';

export const oktaAuth = new OktaAuth({
    clientId: config.oktaClientId,
    issuer: config.oktaIssuer,
    redirectUri: config.baseUrl + '/login/callback',
    scopes: ['openid', 'profile', 'email'],
    tokenManager: {
        autoRenew: !isLocalhost, // silent renewal only in non-localhost
        autoRemove: true
    }
});

 window.oktaAuth = oktaAuth;